import { useState } from 'react'
import './App.css'
import Header from './components/Header'
import Dashboard from './components/Dashboard'
import MemoryGallery from './components/MemoryGallery'
import GoalPlanner from './components/GoalPlanner'
import EmotionTracker from './components/EmotionTracker'
import SmartRecommendation from './components/SmartRecommendation'
import DataVisualization from './components/DataVisualization/DataVisualization'
import VirtualPet from './components/VirtualPet'
import Settings from './components/Settings'

type TabType = 'dashboard' | 'memories' | 'goals' | 'emotions' | 'recommendations' | 'pet' | 'statistics' | 'settings'

function App() {
  const [activeTab, setActiveTab] = useState<TabType>('dashboard')

  const handleNavigate = (tab: string) => {
    setActiveTab(tab as TabType)
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard onNavigate={handleNavigate} />
      case 'memories':
        return <MemoryGallery />
      case 'goals':
        return <GoalPlanner />
      case 'emotions':
        return <EmotionTracker />
      case 'recommendations':
        return <SmartRecommendation />
      case 'pet':
        return <VirtualPet />
      case 'statistics':
        return <DataVisualization />
      case 'settings':
        return <Settings />
      default:
        return <Dashboard onNavigate={handleNavigate} />
    }
  }

  return (
    <div className="app">
      <Header activeTab={activeTab} onTabChange={setActiveTab} />
      <main className="main-content">
        {renderContent()}
      </main>
    </div>
  )
}

export default App